function mergeClassNames(cx, classes, classNames, name) {
  return Object.keys(classes).reduce(function (acc, className) {
    acc[className] = cx(classes[className], classNames != null && classNames[className], name ? "mantine-".concat(name, "-").concat(className) : null);
    return acc;
  }, {});
}

export { mergeClassNames };